import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useUserSession } from '../../../models/hooks/appStateHooks';

export interface IAdminBillingUtilitiesRequest {
	/** The account's Chargify/Maxio customer id (`planDetails.billingReferenceId`). */
	chargifyCustomerId: number;
}

/**
 * Resolves the Chargify/Maxio self-service payment portal URL for a customer via
 * `GET admin/BillingUtilities/GetSelfServicePaymentUrl`. Returns the URL for the caller to open.
 *
 * Mutations have no MutationCache, so the error toast is wired here explicitly.
 */
export function useAdminSelfServicePaymentUrlMutation() {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: ({ chargifyCustomerId }: IAdminBillingUtilitiesRequest) =>
			userSession.webServiceHelper.callAsync<string>(
				`admin/BillingUtilities/GetSelfServicePaymentUrl?chargifyCustomerId=${encodeURIComponent(chargifyCustomerId)}`,
				'GET'
			),
		onError: () => toast.error('Failed to get the self-service payment link. Please try again.'),
	});
}
